import React, { Component } from 'react';
import logo from './title-logo.png';
import './App.css';

import angryred75 from './nagatrons/angry-red-75.png';
import sadblue75 from './nagatrons/sad-blue-75.png';
import happygreen75 from './nagatrons/happy-green-75.png';

import angryred from './nagatrons/angry-red.png';
import sadblue from './nagatrons/sad-blue.png';
import happygreen from './nagatrons/happy-green.png';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            intNagCount: 0,
            nags: [],
            blnShowHelp: false,
            blnShowNotificationDenied: false,
            blnShowWarning: false,
            warningText: "",
            warningType: "Red"
            
        };
    }

    // here for testing setting state externally... incase app is ever mounted by another project???
    /*
    componentWillMount() {
        window.NAG_SETSTATE = (data) => {
            this.setState(data);
        }
    }
    */

    componentDidMount() {

        // register service worker
        if ('serviceWorker' in navigator)
        {
            // if dev
            if (window.location.port === "3000")
            {
                navigator.serviceWorker.register('/sw.js')
                    .then(function(reg) {
                        // registration worked
                        console.log('Registration succeeded. Scope is ' + reg.scope);
                        
                        window.NAG_SWREG = reg;
                        
                        reg.update();

                    }).catch(function(error) {
                        // registration failed
                        console.log('Registration failed with ' + error);
                    });
            }
            
            

            // register message listener
            navigator.serviceWorker.addEventListener('message', function(event){
                //console.log("message event")
                //console.log(event)

                if (event.data === "installed")
                {
                    var reg = event.reg

                    console.log('Install message: Registration succeeded. Scope is ' + reg.scope);
                
                    //window.NAG_SWREG = reg;
                }
                else
                {
                    //console.log("click notification for " + event.data)
                    if (("NAG_HANDLECLICK"+ event.data) in window)
                    {
                        window["NAG_HANDLECLICK"+ event.data]()
                    }
                    
                }
                

            });


            
            
        }
        

        if (!('Notification' in window))
        {
            
            this.setState({
                blnShowNotificationWarning: true
            })
        }
        else if (window.navigator.vendor != null
            && window.navigator.vendor.toLowerCase().indexOf('apple') > -1)
        {
            // if safari
            this.setState({
                blnShowSafariWarning: true
            })
        }

        // add first nag on load
        // OR add saved nags if any exist

        if (localStorage["nags"] == null)
        {
            this.saveNags([]);
        }

        // upgrade localStorage to latest version prior to loading data

        var intLocalStorageVersion = (localStorage["version"] != null ? parseInt(localStorage["version"], 10) : 1)

        if (intLocalStorageVersion === 1
            && !Array.isArray(JSON.parse(localStorage["nags"])))
        {
            var oldDataObject = JSON.parse(localStorage["nags"]);
            var arrDataArray = [];

            Object.keys(oldDataObject).forEach((pstrNagId) => {
                
                arrDataArray.push(oldDataObject[pstrNagId]);

            })

            this.saveNags(arrDataArray);
        }

        if (intLocalStorageVersion <= 2)
        {
            var arrNagsToConvertV2 = JSON.parse(localStorage["nags"]);



            if (Object.keys(arrNagsToConvertV2).length > 0)
            {
                arrNagsToConvertV2.forEach(function(pNag)
                {
                    // set defaults for new properties
                    pNag.blnEnabled = false;
                    pNag.timerType = "interval";
                })
            }

            this.saveNags(arrNagsToConvertV2);


        }

        if (intLocalStorageVersion <= 3)
        {
            var arrNagsToConvertV3 = JSON.parse(localStorage["nags"]);



            if (Object.keys(arrNagsToConvertV3).length > 0)
            {
                arrNagsToConvertV3.forEach(function(pNag)
                {
                    // set defaults for new properties
                    pNag.nagatron = "angry";
                })
            }

            this.saveNags(arrNagsToConvertV3);


        }


        // end version upgrades

        var arrNagsToLoad = [];

        var intHighestNagId = 1; // there will always be 1

        try
        {
            var arrNags = JSON.parse(localStorage["nags"]);



            if (Object.keys(arrNags).length > 0)
            {
                arrNags.forEach(function(pNag)
                {

                    arrNagsToLoad.push(pNag);

                    var intNagId = parseInt(pNag.id.replace('nag', ''), 10)

                    if (intNagId > intHighestNagId)
                    {
                        intHighestNagId = intNagId
                    }
                })
            }
            else
            {
                arrNagsToLoad.push(this.generateNagTemplateData(1))
            }
        }
        catch(ex)
        {
            console.log("caught error on data load")
            console.log(ex)
            // if error loading from localstorage, they just load with single nag, and clear out local storage

            arrNagsToLoad = []
            arrNagsToLoad.push(this.generateNagTemplateData(1))

            
        }

        this.saveNags(arrNagsToLoad,
            () => {
                if (arrNagsToLoad.length <= 2)
                    this.insertAdAtPosition(arrNagsToLoad.length)
                else
                    this.insertAdAtPosition(2)
            });

        this.setState({
            intNagCount: intHighestNagId
        })

    }

    insertAdAtPosition(pintPosition)
    {
        // NO ADS RIGHT NOW. Put this up later if site takes off.
        
        /*

        const arrNags = this.state.nags.slice()

        arrNags.splice(pintPosition, 0, {
            blnIsAd: true,
            id: 'ad1',
            text: "Want to advertise here? Contact support@tinynags.com",
            link: "mailto:support@tinynags.com"
        })

        this.setState({
            nags: arrNags
        })
        */
    }

    countDupes(pNagToCheck) {

        const arrNags = this.state.nags.slice();

        var intDupeCount = 0
        var blnNagFound = false

        arrNags.forEach(pNag=>{

            if (pNag.id !== pNagToCheck.id
                && pNag.title.toLowerCase() === pNagToCheck.title.toLowerCase()
                && !blnNagFound)
            {
                intDupeCount++
            }
            else if (pNag.id === pNagToCheck.id)
            {
                blnNagFound = true
            }

        })


        return intDupeCount

    }

    generateNagTemplateData(pintCount) {
        return {id:"nag" + pintCount, title:"New Nag Text", type:"hours", count: 1, time: "13:00", startNextInterval: false, timerType: "interval", nagatron: "angry"}
    }

    handleAddNag(pstrSampleType) {


        const arrNags = this.state.nags.slice();
        const intNagCount = this.state.intNagCount + 1;

        const oNewNag = this.generateNagTemplateData(intNagCount);

        if (pstrSampleType === "sitstand")
        {
            oNewNag.title = "Switch Sit/Stand Position"
            oNewNag.type = "minutes"
            oNewNag.count = 30
            oNewNag.startNextInterval = true
            oNewNag.timerType = "interval"
            oNewNag.nagatron = "angry"
        }
        else if (pstrSampleType === "gohome")
        {
            oNewNag.title = "Time to go home!"
            oNewNag.type = ""
            oNewNag.count = 0
            oNewNag.startNextInterval = false
            oNewNag.timerType = "time"
            oNewNag.time = "17:00"
            oNewNag.nagatron = "happy"
        }
        

        arrNags.push(oNewNag);

        this.saveNags(arrNags);

        this.setState({
            intNagCount: intNagCount
        })

    }

    handleSelectNagatron(pstrNagId, pstrNagatron) {

        const arrNags = this.state.nags.slice();

        arrNags.forEach((pNag)=>{
            
            

            if (pNag.id === pstrNagId)
            {
                pNag.nagatron = pstrNagatron
            }

        })

        
        
        this.saveNags(arrNags)

    }

    handleDeleteNag(pstrNagId) {
        const arrNags = this.state.nags.slice();

        var intIndex = -1;
        var intCount = 0;

        arrNags.forEach((pNag)=>{
            
            

            if (pNag.id === pstrNagId)
            {
                intIndex = intCount;
            }

            intCount++

        })

        if (intIndex > -1)
        {
            arrNags.splice(intIndex, 1);
        }
        
        this.saveNags(arrNags)
        
    }

    handleValueChange(pstrId, pEvent) {

        const arrNags = this.state.nags.slice()

        //console.log(pstrId)
        //console.log(pEvent.target)
        //console.log(pEvent.target.name)
        //console.log(pEvent.target.value)

        arrNags.forEach(function(pNag)
        {
            if (pNag.id === pstrId)
            {
                if (pEvent.target.type === 'checkbox')
                {
                    pNag[pEvent.target.name] = pEvent.target.checked
                }
                else
                {
                    pNag[pEvent.target.name] = pEvent.target.value
                }
                
            }
        })

        this.saveNags(arrNags)
    }

    handleShowMessage(pstrMessage)
    {
        
        if (pstrMessage === "notificationdenied")
        {
            this.setState({
                blnShowNotificationDenied: true
            })
        }
        else if (pstrMessage === "notificationgranted")
        {
            this.setState({
                blnShowNotificationDenied: false
            })
        }
    }

    // updates state and persists to offline store
    saveNags(parrNags, callback)
    {

        
        // save state
        this.setState({
            nags: parrNags
        }, callback)


        var nags = parrNags.slice()

        // remove ads, loop in reverse
        for (var i = nags.length - 1; i >= 0; i--)
        {
            if (nags[i].blnIsAd)
            {
                nags.splice(i, 1)
            }
        }

        // save to offline
        localStorage["nags"] = JSON.stringify(nags);
        localStorage["version"] = 4;
    }

    handleHelpClick()
    {
        this.setState({
            blnShowHelp: !this.state.blnShowHelp
        })
    }

    handleTypeClick(pstrNagId, pstrNewType)
    {
        const arrNags = this.state.nags.slice()

        arrNags.forEach(function(pNag)
        {
            if (pNag.id === pstrNagId)
            {
                pNag.timerType = pstrNewType
            }
        })

        this.saveNags(arrNags)
    }

    handleAddSample(pstrSampleType)
    {
        this.handleAddNag(pstrSampleType)
    }

    render() {
        return (
            <div className="App">
                <div className={this.state.blnShowNotificationWarning ? 'showWarningRed' : 'hideWarning'} ><b>Notifications are not supported by this browser!</b><br /><br />This website requires a modern <b>desktop</b> version of <a className='link' href='https://www.google.com/chrome'>Google Chrome</a>, Safari, Firefox, Edge or <b>Chrome on Android</b>.</div>
                <div className={this.state.blnShowSafariWarning ? 'showWarningYellow' : 'hideWarning'} ><b>Some features may not work correctly due to limited Notification support in Safari.<br /><br />Consider using <a className='link' href='https://www.google.com/chrome'>Google Chrome</a> instead.</b></div>
                
                <div className="header">
                    <div className='title'><img src={logo} alt='tiny nags.' ></img></div>
                    <div className='titleDescription'>Configurable browser notifications for reminders or stuff you just keep forgetting to do. <i className="fa fa-question-circle helpIcon" aria-hidden="true" onClick={()=>this.handleHelpClick()}></i></div>
                    
                    <div className={this.state.blnShowHelp ? 'showHelp' : 'hideHelp'}>
                        <div style={{textAlign:"center", fontWeight: "bold", fondSize:"16pt"}}>HELP</div>
                        <b>Nag</b>: The text you want to see in your notification<br /><br />
                        <b>Interval vs Time</b>: Determines the type of timer and rules for when the nag should happen
                        <ul>
                        <li><b>Interval</b>: Specify the number of seconds, minutes, hours or days you want between nags<br />
                            - "Start Next Interval" determines if the next timer starts right away or only once you've dismissed the current notification (<i>not fully supported in Firefox</i>)</li>
                        <li><b>Time</b>: Specify the exact time (in 24hr clock) that the nag should happen</li>
                        </ul>

                    </div>

                </div>
                <div className="page">

                    <div className={this.state.blnShowNotificationDenied ? "notificationdenied" : "messagebox"}>
                        <b>Notifications have been disabled in your browser.</b><br />In order to enable nags, you need to enable notifications by doing the following:<br /><br />
                        <ul style={{width: "80%", margin:"0 auto", textAlign: "left"}}>
                            <li>For <b>Google Chrome</b> or <b>Firefox</b><br />
                                <ol style={{width: "90%", margin:"0 auto", textAlign: "left"}}>
                                    <li>Click on the <i className="fa fa-info-circle" aria-hidden="true"></i> icon on the left of the address bar.</li>
                                    <li>Unblock Notifications:
                                        <ul>
                                            <li>In <b>Google Chrome</b>: Change the dropdown beside "Notifications" from 'Block' to 'Allow'</li>
                                            <li>In <b>Firefox</b>: Click the <i className="fa fa-times" aria-hidden="true"></i> beside "Notifications"</li>
                                        </ul>
                                    </li>

                                </ol>
                            </li>
                            <li>For <b>Safari</b>: Safari Menu <i className="fa fa-arrow-right" aria-hidden="true"></i> Preferences <i className="fa fa-arrow-right" aria-hidden="true"></i> Notifications. Then click 'Allow' beside www.tinynags.com</li>
                            <li>For <b>Edge</b>: Click the <i className="fa fa-ellipsis-h" aria-hidden="true"></i> icon in the upper right <i className="fa fa-arrow-right" aria-hidden="true"></i> Settings <i className="fa fa-arrow-right" aria-hidden="true"></i> View Advanced <i className="fa fa-arrow-right" aria-hidden="true"></i> Notifications <i className="fa fa-arrow-right" aria-hidden="true"></i> Manage. Then click 'On' beside www.tinynags.com</li>
                        </ul>
                    </div>
                    <button onClick={()=>this.handleAddNag()} className="newNag">Add New Nag</button>
                    <div className="exampleBox">
                        <i>Examples:</i>&nbsp;
                        <span className="sampleButton" onClick={()=>this.handleAddSample("sitstand")}>Sit/Stand reminder</span>&nbsp;|&nbsp;
                        <span className="sampleButton" onClick={()=>this.handleAddSample("gohome")}>Time To Go Home</span>
                    </div>

                    <div style={{textAlign: "center"}}>
                    <Nags nags={this.state.nags} handleValueChange={this.handleValueChange.bind(this)} handleDeleteNag={this.handleDeleteNag.bind(this)} handleSelectNagatron={this.handleSelectNagatron.bind(this)}  handleTypeClick={this.handleTypeClick.bind(this)} handleShowMessage={this.handleShowMessage.bind(this)} countDupes={this.countDupes.bind(this)} />
                    </div>
                    <p className='notice'>
                        <b>NOTE: You must leave this browser tab open in order for notifications to work (it does NOT need to be visible).</b><br />
                        <br />
                        Depending on your browser's notification settings, the notification may not stay on screen for very long. Please contact us via <a className='link' href='mailto:hello@tinynags.com'>email</a> or <a className='link' href='https://www.twitter.com/tinynagsapp'>twitter @tinynagsapp</a> for help with reconfiguring your settings or refer to your browser's help documents.<br />
                        
                    </p>

                    
                </div>
                
                
            </div>


        );
    }
}

function Nags(props)
{
    
    var arrNagsDOM = props.nags.map(function(nag) {

        return (
            <Nag key={nag.id} data={nag} handleValueChange={props.handleValueChange} handleDeleteNag={props.handleDeleteNag} handleSelectNagatron={props.handleSelectNagatron} handleTypeClick={props.handleTypeClick} handleShowMessage={props.handleShowMessage} countDupes={props.countDupes} />
        );
    });

    return (
        <div className="nags">
            {arrNagsDOM}
        </div>
    );
}

class Nag extends Component
{


    constructor(props)
    {
        super(props);

        this.state = {
            intIntervalId: null,
            strTimer: "--:--:--",
            intCountdownIntervalId: null
        }
    }

    componentWillMount() {

        window["NAG_HANDLECLICK" + this.props.data.id] = () => {

            //console.log("handleNotificationClick for " + this.props.data.id);

            var blnIsNagDisabled = this.state.intIntervalId == null;

            if (this.props.data.startNextInterval
                && !blnIsNagDisabled)
            {
                this.configureNag()
            }

        }
        

    }

    componentDidMount() {
        if (this.props.data.blnEnabled)
        {
            this.startTimer(this.props.data)
        }
        
    }

    componentDidUpdate() {
        //console.log(this.props.data.id + " updated")
    }

    handleToggleNag() {
      


        var fnToggleNagUpdateState = () =>
        {
            this.props.handleValueChange(this.props.data.id, {
                // hand cranked event object with all required values set for handler

                target: {
                    name: "blnEnabled",
                    value: blnEnabled
                }
                
            })
        }


        const blnEnabled = !this.props.data.blnEnabled

        if (blnEnabled)
        {
            this.checkPermissions (()=>{
                this.configureNag()
                fnToggleNagUpdateState()
            })
            
        }
        else
        {
            this.cancelNag()
            fnToggleNagUpdateState()
        }

        
        
        
        
    }
  
    checkPermissions(pSuccessCallback) {
        // Let's check if the browser supports notifications
        if (!("Notification" in window)) {
            alert("This website requires a modern desktop version of Chrome, Safari, Firefox, Edge or Chrome on Android. Notifications are not supported by this browser!");
        }

        // Let's check whether notification permissions have already been granted
        else if (Notification.permission === "granted") {
            // If it's okay let's create a notification
            this.props.handleShowMessage("notificationgranted")
            pSuccessCallback()
        }
        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== "denied") {

            // TODO: Display instructions and reason for why user needs to click 'Allow' before promoting for permission
            // -- otherwise it won't work.

            var blnResponse = window.confirm("You will be prompted to enable Notifications. tiny nags will only function correctly if you select 'Allow'");

            if (blnResponse)
            {
                Notification.requestPermission((permission) => {
                    // If the user accepts, let's create a notification
                    if (permission === "granted") {
                        this.props.handleShowMessage("notificationgranted")
                        pSuccessCallback()
                    }
                    else if (permission === "denied")
                    {
                        this.props.handleShowMessage("notificationdenied")
                    }
                });
            }
            
        }
        else
        {
            // user previously denied, let them know why the notification won't work and give instructions on re-enabling

            this.props.handleShowMessage("notificationdenied")
        }
        
        // At last, if the user has denied notifications, and you 
        // want to be respectful there is no need to bother them any more.
    }


    cancelNag()
    {
        clearInterval(this.state.intIntervalId)
        clearInterval(this.state.intCountdownIntervalId)

        this.setState({
            intIntervalId: null,
            intCountdownIntervalId: null,
            strTimer: "--:--:--"
        })

        return null
    }

    handleSelectNagatron(pstrNagatron)
    {
        this.props.handleSelectNagatron(this.props.data.id, pstrNagatron)
    }
    
    handleDeleteNag()
    {
        this.cancelNag()
        this.props.handleDeleteNag(this.props.data.id)
    }

    configureNag()
    {
        this.cancelNag()


        var intNotificationTimeMS = 0;

        if (this.props.data.timerType === "interval")
        {


            var intIntervalSeconds = 0;
            var intIntervalCount = this.props.data.count        
            var strIntervalType = this.props.data.type

            //console.log(intIntervalCount)
            //console.log(strIntervalType)
            //console.log(this.props.data.title)

            switch(strIntervalType) {
                case 'seconds':
                    intIntervalSeconds = intIntervalCount;
                    break;
                case 'minutes':
                    intIntervalSeconds = intIntervalCount * 60;
                    break;
                case 'hours':
                    intIntervalSeconds = intIntervalCount * 60 * 60;
                    break;
                case 'days':
                    intIntervalSeconds = intIntervalCount * 60 * 60 * 24;
                    break;
                case 'weeks':
                    intIntervalSeconds = intIntervalCount * 60 * 60 * 24 * 7;
                    break;
                default:
                    intIntervalSeconds = -1;
            }

            var intIntervalMS = intIntervalSeconds  * 1000;

            intNotificationTimeMS = (new Date()).getTime() + intIntervalMS
        }
        else if (this.props.data.timerType === "time")
        {
            // parse the time (either h:m or h:m:s) -- support 24hr clock only right now

            var arrTimeParts = this.props.data.time.split(":")

            var intSeconds = 0;

            intSeconds += parseInt(arrTimeParts[0], 10) * 60 * 60
            intSeconds += parseInt(arrTimeParts[1], 10) * 60

            if (arrTimeParts.length === 3)
            {
                intSeconds += parseInt(arrTimeParts[2], 10)
            }

            var intTimeMS = intSeconds  * 1000;


            // if time has passed for today, calculate ms for tomorrow
            // else, calculate for today

            var dtNow = new Date()
            

            var intCurrentTimeMS = (dtNow.getHours() * 60 * 60 + dtNow.getMinutes() * 60  + dtNow.getSeconds()) * 1000
                + dtNow.getMilliseconds()

            var intTodayMS = dtNow.getTime()
            intTodayMS -= intCurrentTimeMS

            if (intTodayMS + intTimeMS < dtNow.getTime())
            {
                // time has passed, set for tomorrow
                var dtTomorrow = new Date(intTodayMS)
                dtTomorrow.setDate(dtTomorrow.getDate() + 1);

                intNotificationTimeMS = dtTomorrow.getTime() + intTimeMS
            }
            else
            {
                intNotificationTimeMS = dtNow.getTime() - intCurrentTimeMS + intTimeMS
            }

            //console.log("new notification time")
            //console.log(intNotificationTimeMS)
        }

        

        

        if (intIntervalSeconds <= 0)
        {
            alert("Invalid interval: " + intIntervalCount + " " + strIntervalType);
        }
        else
        {

            this.props.handleValueChange(this.props.data.id, {
                // hand cranked event object with all required values set for handler

                target: {
                    name: "nextNotificationTimeMS",
                    value: intNotificationTimeMS
                }
                
            })

            this.startTimer(this.props.data, intNotificationTimeMS)

            

        }
          
    }

    // pNewNotificationTimeMS is provided on NEW nag configurations
    // -- it is pulled from pNag only when page is refreshed and value is pulled from local storage
    startTimer(pNag, pNewNotificationTimeMS)
    {

        //console.log("starting timer for")
        //console.log(pNag.id)

        var intNewNotificationTime = 0; // calculate


        if (pNewNotificationTimeMS == null)
        {
            intNewNotificationTime = pNag.nextNotificationTimeMS
        }
        else
        {
            intNewNotificationTime = pNewNotificationTimeMS
        }

        var intIntervalMS = intNewNotificationTime - (new Date()).getTime()

        //console.log("notification in x seconds")
        //console.log(intIntervalMS / 1000);

        var intervalId = setTimeout(()=>{

            //console.log("timer should fire now");
            //console.log(pNag.title)
            //console.log(this.state.intIntervalId)

            var strNagTitle = pNag.title

            // check how many other nags with lower ids exist, then add count + 1

            var intDupeCount = this.props.countDupes(pNag)

            if (intDupeCount > 0)
            {
                strNagTitle += " (" + (intDupeCount + 1) + ")"
            }

            var reactNagatronIcon = {angryred}

            if (this.props.data.nagatron === "angry")
            {
                reactNagatronIcon = {angryred}
            }
            else if (this.props.data.nagatron === "sad")
            {
                reactNagatronIcon = {sadblue}
            }
            else if (this.props.data.nagatron === "happy")
            {
                reactNagatronIcon = {happygreen}
            }

            // unwrap the nagatron image to get its path
            var strNagatronIconPath = reactNagatronIcon[Object.keys(reactNagatronIcon)[0]]

            //console.log(reactNagatronIcon)
            //console.log(strNagatronIconPath)

            if ('serviceWorker' in navigator)
            {
                navigator.serviceWorker.ready.then(registration => {
                    registration.showNotification(strNagTitle,
                    {
                        requireInteraction: true,
                        icon: strNagatronIconPath,
                        data: {
                            nagId: this.props.data.id
                        }
                    });
                });
            }
            else
            {
                //window["NAG_HANDLECLICK"+ event.data]()
                var n = new Notification(strNagTitle,
                    {
                        requireInteraction: true,
                        icon: strNagatronIconPath
                    });

                n.onclick = ()=>{
                        
                    window["NAG_HANDLECLICK" + this.props.data.id]()

                    n.close();
                };

                // onclose is deprecated but needed here if user clicks 'close' vs clicking on notification body
                n.onclose = n.onclick;
            }
            

            

            if (!pNag.startNextInterval)
            {
                this.configureNag()
            }
            


        }, intIntervalMS);


        // countdown interval
        var intCountdownIntervalId = setInterval(() => {

            var intNowMS = (new Date()).getTime()

            var intDiffMS = intNewNotificationTime - intNowMS

            //console.log(intDiffMS)

            var intDiffSeconds = Math.round(intDiffMS/1000)

            var intHours = 0;
            var intMins = 0;
            var intSeconds = 0;

            if (intDiffSeconds > 0)
            {
                intHours = parseInt(intDiffSeconds / (60*60), 10)

                intDiffSeconds -= intHours * (60*60)

                intMins = parseInt(intDiffSeconds / 60, 10)

                intDiffSeconds -= intMins * 60

                intSeconds = intDiffSeconds
            }


            this.setState({
                strTimer: (intHours < 10 ? "0" + intHours : intHours) + ":" + (intMins < 10 ? "0" + intMins : intMins) + ":" + (intSeconds < 10 ? "0" + intSeconds : intSeconds)
            })

            if (intDiffMS <= 0)
            {
                // clear interval with current id value, not state incase it has been updated already
                clearInterval(intCountdownIntervalId)
            }

        }, 500); // run every half a second incase it gets out of sync, display shouldn't be too far off or show it skipping 2 seconds

        this.setState({
            intIntervalId: intervalId,
            intCountdownIntervalId: intCountdownIntervalId
        })
    }

    clickAd(pstrLink)
    {
        window.open(pstrLink)
    }

    render() {
        
        if (this.props.data.blnIsAd)
        {
            return (
                <div className="ad" onClick={()=>this.clickAd(this.props.data.link)}><br /><br />{this.props.data.text}</div>
                )
        }
        else
        {
            return (
                <div className='nag-wrapper'>
                    <img src={angryred75} alt='angry-red' className={this.props.data.nagatron === "angry" ? 'nagatron-active nagatron-left' : 'nagatron-left'} onClick={()=>this.handleSelectNagatron("angry")} />
                    <img src={sadblue75} alt='sad-blue' className={this.props.data.nagatron === "sad" ? 'nagatron-active nagatron-middle' : 'nagatron-middle'} onClick={()=>this.handleSelectNagatron("sad")} />
                    <img src={happygreen75} alt='happy-green' className={this.props.data.nagatron === "happy" ? 'nagatron-active nagatron-right' : 'nagatron-right'} onClick={()=>this.handleSelectNagatron("happy")} />

                    <div className={
                        this.props.data.blnEnabled ? 'nag-active' : 'nag'
                      }>

                        <i className="fa fa-times" aria-hidden="true" onClick={()=>this.handleDeleteNag()} style={{float: "right", cursor: "pointer"}}></i>

                        <div>
                            <div className="nagtitle">Next Nag in <span className="nagtimer">{this.state.strTimer}</span></div>
                            <input name='title' className="titleInput" defaultValue={this.props.data.title} onChange={(pEvent)=>this.props.handleValueChange(this.props.data.id, pEvent)} />
                        </div>
                        <div style={{textAlign: "center", marginTop: "5px"}}>
                            <button className={this.props.data.timerType === 'interval' ? 'typeIntervalEnabled' : 'typeInterval'} onClick={()=>this.props.handleTypeClick(this.props.data.id, "interval")} disabled={this.props.data.blnEnabled}>Interval</button><button className={this.props.data.timerType === 'time' ? 'typeTimeEnabled' : 'typeTime'} onClick={()=>this.props.handleTypeClick(this.props.data.id, "time")} disabled={this.props.data.blnEnabled}>Time</button>
                        </div>
                        <div className="timerTypeControls">
                            <div className={this.props.data.timerType === 'time' ? 'timerTypeControl' : 'timerTypeControlHidden'}>
                                Time: <input name='time' className="timeInput" defaultValue={this.props.data.time} onChange={(pEvent)=>this.props.handleValueChange(this.props.data.id, pEvent)} disabled={this.props.data.blnEnabled} />
                            </div>
                            <div className={this.props.data.timerType === 'interval' ? 'timerTypeControl' : 'timerTypeControlHidden'}>
                                <b>Every:</b>&nbsp;
                                <input type='number' name='count' className="countInput" defaultValue={this.props.data.count}  onChange={(pEvent)=>this.props.handleValueChange(this.props.data.id, pEvent)} disabled={this.props.data.blnEnabled} />&nbsp;
                                <select name='type' className="typeInput" defaultValue={this.props.data.type} onChange={(pEvent)=>this.props.handleValueChange(this.props.data.id, pEvent)} disabled={this.props.data.blnEnabled} >
                                    <option value='seconds'>Seconds</option>
                                    <option value='minutes'>Minutes</option>
                                    <option value='hours'>Hours</option>
                                    <option value='days'>Days</option>
                                    <option value='weeks'>Weeks</option>
                                </select>
                                <br />
                                <label><input type='checkbox' name='startNextInterval' defaultChecked={this.props.data.startNextInterval}  onChange={(pEvent)=>this.props.handleValueChange(this.props.data.id, pEvent)} disabled={this.props.data.blnEnabled} /> Start next interval only after dismissing notification</label>
                            </div>
                        </div>
                        

                        <div className='buttonBox'>
                            { !this.props.data.blnEnabled ? <button className='startNag' onClick={() =>this.handleToggleNag()}>Nag Me!</button> : null }
                            { this.props.data.blnEnabled ? <button className='stopNag' onClick={() =>this.handleToggleNag()}>Stop Nagging Me!</button> : null }
                        </div>


                          
                    </div>
                </div>
            );
        }
      }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js